// Sentinel inserted by `collapseMultilineTableRows` for each newline consumed
// when joining a multi-line table row onto one line. The marked table-cell
// renderer swaps it back to `\n` and re-parses the cell as block markdown so
// paragraphs, lists, and other block constructs render inside `<td>` / `<th>`.
const CELL_NL_SENTINEL = '§nl§';
const CELL_NL_SENTINEL_RE = /§nl§/g;

export { CELL_NL_SENTINEL, CELL_NL_SENTINEL_RE };
